import * as React from "react";
import { Box } from "theme-ui";

export default function PageContainer(props) {
  return (
    <Box
      {...props}
      sx={{
        maxWidth: ["100%", "100%", "1024px"],
        margin: [0, 0, "0 auto"],
        ...props.sx,
      }}
    ></Box>
  );
}
